import { clubbiStyled } from 'clubbi-ui'

export const StyledContainer = clubbiStyled('div')(({ theme }) => ({
  textAlign: 'left',
  fontSize: theme.typography.fontSize2XS,
  [theme.breakpoints.up('md')]: {
    fontSize: '16px',
  },
}))

export const StyledLabel = clubbiStyled('div')(({ theme }) => ({
  fontWeight: 400,
}))

export const StyledRowWrapper = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  gap: '4px',
}))

export const StyledPaymentType = clubbiStyled('div')(({ theme }) => ({
  fontWeight: 600,
}))

export const StyledValue = clubbiStyled('div')(({ theme }) => ({
  fontWeight: 500,
}))

export const StyledTitle = clubbiStyled('div')(({ theme }) => ({
  margin: '10px 0',
  fontSize: theme.typography.fontSizeXXS,
  fontWeight: 600,
  color: theme.palette.brandBlack.main,
  [theme.breakpoints.up('md')]: {
    fontSize: '16px',
  },
}))

export const StyledInstallmentContainer = clubbiStyled('div')(({ theme }) => ({
  margin: '10px 0',
  border: `1px ${theme.palette.brandGrey[20]} solid`,
  borderRadius: '5px',
  padding: '10px',
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: theme.typography.fontSize2XS,
  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.fontSizeXXS,
  },
}))

export const StyledInstallmentsInfos = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
}))

export const StyledHeader = clubbiStyled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

export const StyledInstallmentNumber = clubbiStyled('div')(({ theme }) => ({
  fontSize: theme.typography.fontSizeXXS,
  fontWeight: 600,
  [theme.breakpoints.up('md')]: {
    fontSize: '14px',
  },
}))

export const StyledStatus = clubbiStyled('div')<{ status: string }>(({ theme, status }) => ({
  display: 'flex',
  fontWeight: 600,
  flexDirection: 'row',
  color:
    status === 'PENDING'
      ? theme.palette.brandYellow[50]
      : status === 'RECEIVED' || status === 'CONFIRMED'
      ? theme.palette.brandSuccess[70]
      : status === 'OVERDUE' || status === 'DUNNING_REQUESTED'
      ? theme.palette.brandWarning[50]
      : theme.palette.brandGrey[80],
}))

export const StyledLink = clubbiStyled('a')(({ theme }) => ({
  color: theme.palette.brandPurple.main,
  fontWeight: 500,
  textDecoration: 'underline',
  '&:hover': {
    color: theme.palette.brandPurple.main,
  },
}))
